import config from '../config'
import React from 'react'
import { Cookies } from 'react-cookie'
import request from 'request-promise'

const UserStateContext = React.createContext()
const UserDispatchContext = React.createContext()
const cookies = new Cookies()

function userReducer (state, action) {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
      return { ...state, accessToken: cookies.get('accessToken') }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}

function UserProvider ({ children }) {
  const [state, dispatch] = React.useReducer(userReducer, {
    accessToken: cookies.get('accessToken')
  })

  return (
    <UserStateContext.Provider value={state}>
      <UserDispatchContext.Provider value={dispatch}>
        {children}
      </UserDispatchContext.Provider>
    </UserStateContext.Provider>
  )
}

function useUserState () {
  const context = React.useContext(UserStateContext)
  if (context === undefined) {
    throw new Error('useUserState must be used within a UserProvider')
  }
  return context
}

function useUserDispatch () {
  var context = React.useContext(UserDispatchContext)
  if (context === undefined) {
    throw new Error('useUserDispatch must be used within a UserProvider')
  }
  return context
}

async function isValidToken (token) {
  try {
    const response = await request({
      url: `${config.apiUrl}/clients`,
      method: 'head',
      auth: { bearer: token },
      resolveWithFullResponse: true,
      simple: false
    })
    return response.statusCode !== 401
  } catch (error) {
    return false
  }
}

function getLandingLocation (stateCode) {
  if (stateCode) {
    const location = cookies.get(stateCode)
    if (location) {
      cookies.remove(stateCode)
      return location
    }
  }
  return '/app/dashboard'
}

async function loginUser (
  dispatch,
  history,
  token,
  expiry,
  stateCode
) {
  if (token) {
    if (await isValidToken(token)) {
      cookies.set('accessToken', token, {
        path: '/',
        maxAge: Number(expiry || 86400),
        secure: process.env.NODE_ENV === 'production'
      })
      dispatch({ type: 'LOGIN_SUCCESS' })
      history.push(getLandingLocation(stateCode))
    } else {
      signOut()
    }
  } else {
    if (cookies.get('accessToken')) {
      dispatch({ type: 'LOGIN_SUCCESS' })
      history.push(getLandingLocation(stateCode))
    } else {
      signOut()
    }
  }
  cookies.getAll()
}

function signOut (returnLocation) {
  if (cookies.get('accessToken')) {
    cookies.remove('accessToken', { path: '/' })
  }
  let stateCode = ''
  if (returnLocation) {
    const { pathname, search, key } = returnLocation
    cookies.set(key, { pathname, search }, {
      path: '/',
      maxAge: 3600 * 1,
      secure: process.env.NODE_ENV === 'production'
    })
    stateCode = key
  }
  const redirectUrl = config.redirectUri
  let authUrl = `${config.authUrl}?state=${stateCode}`
  authUrl += '&scope=read:client write:client write:alarm.test'
  authUrl += `&response_type=code&client_id=${config.clientId}&redirect_uri=${redirectUrl}`
  window.location.assign(authUrl)
}

export { UserProvider, useUserState, useUserDispatch, loginUser, signOut }
